/**
 * Where the journeys' "Improve my CV" / "Keep using my benefits" actions go.
 *
 * The app has no one-tap "AI improve" action on the CV screen, so these open
 * the career chat with a prefilled "Improve my CV introduction" prompt (the
 * welcome card's promise: Nova suggests a clearer introduction, the person
 * decides what to keep). `dismissTo` leaves any presented formSheet atomically
 * (see useUpgradeFromFormSheet) instead of stacking a card above it.
 */
import type { Router } from 'expo-router';

type DismissRouter = Pick<Router, 'dismissTo'>;

export function openImproveCv(router: DismissRouter, prompt: string) {
  router.dismissTo({ pathname: '/(app)/chat', params: { prompt } } as never);
}

/** The person's own profile page ("View my profile - See what recruiters see"). */
export function openOwnProfile(router: DismissRouter) {
  router.dismissTo('/(app)/profile' as never);
}

/** The person's CV. */
export function openOwnCv(router: DismissRouter) {
  router.dismissTo('/(app)/cv' as never);
}
